export enum DiscountTypes {
  PERCENT = 'percent',
  DOLLAR = 'dollar'
}
